var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEduadvice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.000000pt",
    height: "25.000000pt",
    viewBox: "0 0 25.000000 25.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,25.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 175 c0 -9 8 -18 18 -21 56 -18 63 -44 15 -56 -20 -5 -33 -15 -33 -24 0 -13 8 -15 43 -10 52 7 52 7 105 0 23 -3 42 -2 42 3 0 15 -23 33 -41 33 -42 0 -29 46 14 52 12 2 23 11 25 21 3 16 -1 18 -34 12 -21 -3 -43 -10 -48 -15 -6 -6 -14 -6 -22 1 -6 5 -28 12 -48 14 -28 4 -36 1 -36 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 133 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduadvice);
export default __webpack_public_path__ + "static/media/eduadvice.1552a033519b2b8ae57a84580fd9abc7.svg";
export { ForwardRef as ReactComponent };